import { joinURL } from '../../../utilities';
import { standAlonePathName } from '../../area-pathnames';
import { adminAreaPathName, organizationTabPathName } from '../admin-area-pathnames';

export const userProfilesListPathName = 'user-profile';

export const usersListPathName = 'users';
export const subjobcentersPathName = 'subjobcenters';
export const userCreatePathName = 'edit';

export const teamListPathName = 'teams';

export const externalOperatorPathName = 'externaloperator';
export const externalOperatorAgreementsEditPathName = '/:externalOperatorAgreementId';

export const externalOperatorResponsibilityAreaPathName = 'external-operator-responsibility-area';

export const socialProviderUnitsPathName = 'social-provider-units';

export function getEditUserPath(userId?: string) {
  const userPath = joinURL('/', standAlonePathName, adminAreaPathName, organizationTabPathName, usersListPathName, userCreatePathName);
  return userId ? joinURL(userPath, userId) : userPath;
}
